import { render } from "./BrandStore.vue?vue&type=template&id=38a8567e&scoped=true"
import script from "../js/brand-store.js?vue&type=script&lang=js"
export * from "../js/brand-store.js?vue&type=script&lang=js"

import "./BrandStore.vue?vue&type=style&index=0&id=38a8567e&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a8567e"]])

export default __exports__